import React from "react"

import { exists } from "shared/lib/exists"

import { InputChangeBehavior } from "../input/Input"
import { NumberInput } from "../input/number/NumberInput"
import { RJSFFormReadonlyField } from "./RJSFFormStringField"
import { RJSFFormFieldProps } from "./types"

export const RJSFFormNumberField = React.memo(
  (
    props: RJSFFormFieldProps & {
      FieldInformationRenderer?: React.ComponentType<RJSFFormFieldProps>
    }
  ) => {
    const { schema, path, isDisabled, FieldInformationRenderer } = props

    const minInfo = exists(schema.minimum) ? `Min: ${schema.minimum}` : ""
    const maxInfo = exists(schema.maximum) ? `Max: ${schema.maximum} ` : ""

    const infoText = [minInfo, maxInfo].join(" ")

    if (schema.readOnly) {
      return <RJSFFormReadonlyField {...props} />
    }

    return (
      <div className="rjsf-form__field-container">
        <div className="rjsf-form__field">
          <NumberInput.Root
            name={path}
            disabled={isDisabled}
            hasError={!!schema.error}
            label={schema.title ?? ""}
            min={schema.minimum}
            max={schema.maximum}
            changeBehavior={InputChangeBehavior.BLUR}
          >
            <NumberInput.Label />

            <NumberInput.Group>
              <NumberInput.Focus>
                <NumberInput.Input />
                <NumberInput.Affix>{schema.unit}</NumberInput.Affix>
              </NumberInput.Focus>
            </NumberInput.Group>

            <NumberInput.ErrorMessage>{schema.error}</NumberInput.ErrorMessage>
            <NumberInput.InfoMessage>{infoText}</NumberInput.InfoMessage>
          </NumberInput.Root>
          {FieldInformationRenderer ? (
            <div className="rjsf-form__field-information">
              <FieldInformationRenderer {...props} />
            </div>
          ) : null}
        </div>
      </div>
    )
  }
)
